import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
// import './assets/jquery.min.js'
// import './assets/owl.carousel.min.js'
import Particles from "react-tsparticles";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

function Home() {
  const [current_tab, setCurrentTab] = useState("");
  const [responsive, setResponsive] = useState({
    0: {
      items: 1,
    },
    450: {
      items: 2,
    },
    600: {
      items: 3,
    },
    1000: {
      items: 5,
    },
  });
  const particlesInit = (main) => {
    console.log(main);
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };
  function handleClick(val) {
    setCurrentTab(val);
  }
  return (
    <div>
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: {
            color: {
              value: "#0000",
            },
          },
          fpsLimit: 60,
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "bubble",
              },
              onclick: {
                enable: true,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 400,
                line_linked: {
                  opacity: 1,
                },
              },
              bubble: {
                distance: 83.91608391608392,
                size: 1,
                duration: 3,
                opacity: 1,
                speed: 3,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
              remove: {
                particles_nb: 2,
              },
            },
          },
          particles: {
            number: {
              value: 355,
              density: {
                enable: true,
                value_area: 789.1476416322727,
              },
            },
            color: {
              value: "#ffffff",
            },
            shape: {
              type: "circle",
              stroke: {
                width: 0,
                color: "#000000",
              },
              polygon: {
                nb_sides: 5,
              },
              image: {},
            },
            opacity: {
              value: 0.48927153781200905,
              random: false,
              anim: {
                enable: true,
                speed: 5,
                opacity_min: 0,
                sync: false,
              },
            },
            size: {
              value: 2,
              random: true,
              anim: {
                enable: true,
                speed: 2,
                size_min: 0,
                sync: false,
              },
            },
            line_linked: {
              enable: false,
              distance: 150,
              color: "#ffffff",
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 0.2,
              direction: "none",
              random: true,
              straight: false,
              out_mode: "out",
              bounce: false,
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200,
              },
            },
          },
          detectRetina: true,
        }}
      />
      <div id="wrapper">
        {/* header begin  */}
        <Navbar />
        {/* header close  */}

        {/* content begin  */}
        <div className="no-bottom no-top" id="content">
          <div id="top"></div>

          {/* banner */}
          <section
            id="section-hero"
            aria-label="section"
            className="pt20 pb20 vh-100"
            style={{
              background: "url(images/background/tiger.png) 0% 0% / cover",
              height: "100%!important",
            }}
          >
            {/* <div id="particles-js"></div> */}
            <div className="v-center">
              <div className="container">
                <div className="row align-items-center justify-content-center">
                  <div className="col-lg-6 col-md-8 text-center">
                    <div className="spacer-single"></div>
                    <img
                      alt="weblogo"
                      className="wow fadeInUp"
                      src={"images/log.png"}
                    />
                    {/* <h2 className="wow fadeInUp" data-wow-delay=".5s"><span className="text-uppercase id-color-2 brand_name" data-shadow="Billionaire Tigers">Billionaire Tigers</span></h2> */}
                    <svg
                      className="animated_headline"
                      width="100%"
                      height="100%"
                    >
                      <text
                        x="50%"
                        y="60%"
                        className="textt"
                        data-wow-delay=".5s"
                        textAnchor="middle"
                      >
                        Billionaire Tigers
                      </text>
                    </svg>
                    <h1 className="wow fadeInUp d-none" data-wow-delay=".75s">
                      Welcome to our minting website.
                    </h1>
                    <p
                      className="wow fadeInUp lead text-white main_desc"
                      data-wow-delay="1s"
                      style={{
                        color: "var(--primary-color)",
                        fontWeight: 600,
                      }}
                    >
                      Our brilliant NFT’s not only look absolutely incredible
                      but they also produce tiger tokens every single week with
                      our staking opportunities
                    </p>
                    <div className="spacer-10"></div>
                    <Link
                      to="/mint"
                      className="btn-main wow fadeInUp lead"
                      data-wow-delay="1.25s"
                    >
                      Mint now
                    </Link>
                  </div>
                  <div className="col-md-6 xs-hide d-none">
                    <img
                      src="images/banner1.png"
                      className="img-fluid wow fadeInUp"
                      data-wow-delay=".75s"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* banner */}

          {/* items */}
          <section id="section-collections" className="pt50 pb50">
            <div className="container">
              <div className="row wow fadeIn">
                <div className="col-lg-12">
                  <h2 className="style-2 about_h2">New Items</h2>
                </div>
                <OwlCarousel
                  id="carousel1"
                  className="owl-theme wow fadeIn"
                  loop
                  autoplay
                  autoplayHoverPause
                  smartSpeed={450}
                  margin={10}
                  nav
                  responsive={responsive}
                >
                  <div className="item text-center">
                    <div className="nft__item style-2">
                      <div className="nft__item_wrap">
                        <Link to="/">
                          <img
                            src="images/tiger_art/tig1c.png"
                            className="lazy nft__item_preview"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="item text-center">
                    <div className="nft__item style-2">
                      <div className="nft__item_wrap">
                        <Link to="/">
                          <img
                            src="images/tiger_art/tig2c.png"
                            className="lazy nft__item_preview"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="item text-center">
                    <div className="nft__item style-2">
                      <div className="nft__item_wrap">
                        <Link to="/">
                          <img
                            src="images/tiger_art/tig3c.png"
                            className="lazy nft__item_preview"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="item text-center">
                    <div className="nft__item style-2">
                      <div className="nft__item_wrap">
                        <Link to="/">
                          <img
                            src="images/tiger_art/Tiger4.png"
                            className="lazy nft__item_preview"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="item text-center">
                    <div className="nft__item style-2">
                      <div className="nft__item_wrap">
                        <Link to="/">
                          <img
                            src="images/tiger_art/Tiger5.png"
                            className="lazy nft__item_preview"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="item text-center">
                    <div className="nft__item style-2">
                      <div className="nft__item_wrap">
                        <Link to="/">
                          <img
                            src="images/tiger_art/Tiger6.png"
                            className="lazy nft__item_preview"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="item text-center">
                    <div className="nft__item style-2">
                      <div className="nft__item_wrap">
                        <Link to="/">
                          <img
                            src="images/tiger_art/Baby1.png"
                            className="lazy nft__item_preview"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="item text-center">
                    <div className="nft__item style-2">
                      <div className="nft__item_wrap">
                        <Link to="/">
                          <img
                            src="images/tiger_art/Baby2.png"
                            className="lazy nft__item_preview"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </OwlCarousel>
              </div>
              <div className="spacer-single"></div>
            </div>
          </section>
          {/* items */}

          <br />
          {/* info */}
          <section id="section-text" className="no-top">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 col-md-6 mb-sm-30">
                  <div className="feature-box f-boxed style-3">
                    <i className="wow fadeInUp bg-color-2 i-boxed icon_wallet"></i>
                    <div className="text">
                      <h4 className="wow fadeInUp">
                        5 Ethereum giveaways on our discord and twitter
                      </h4>
                    </div>
                    <i className="wm icon_wallet"></i>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-sm-30">
                  <div className="feature-box f-boxed style-3">
                    <i className="wow fadeInUp bg-color-2 i-boxed fa fa-cloud-upload"></i>
                    <div className="text">
                      <h4 className="wow fadeInUp">
                        Most engaged users in our discord receive NFT’s as
                        prizes.
                      </h4>
                    </div>
                    <i className="wm fa fa-cloud-upload"></i>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-sm-30">
                  <div className="feature-box f-boxed style-3">
                    <i className="wow fadeInUp bg-color-2 i-boxed icon_tags_alt"></i>
                    <div className="text">
                      <h4 className="wow fadeInUp">
                        50% of secondary sales go towards community wallet.
                      </h4>
                    </div>
                    <i className="wm icon_tags_alt"></i>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-sm-30">
                  <div className="feature-box f-boxed style-3">
                    <i className="wow fadeInUp bg-color-2 i-boxed icon_tags_alt"></i>
                    <div className="text">
                      <h4 className="wow fadeInUp">
                        Transparent and fair pricing at 0.000 ETH per
                        [tokenname].
                      </h4>
                    </div>
                    <i className="wm icon_tags_alt"></i>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* info */}

          {/* about */}
          <section id="section-about" aria-label="section">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-3">
                  <div
                    className="aboutimgdiv"
                    style={{ background: "#E3D666", borderRadius: "100%" }}
                  >
                    <img
                      src="images/tiger_art/Tiger2.png"
                      className="about_token_img w-100"
                      alt=""
                    />
                  </div>
                  <span></span>
                </div>
                <div className="col-md-9" style={{ margin: "auto" }}>
                  <h2 className="style-2 about_h2">About Billionaire Tigers</h2>
                  <p className="text-white">
                    Earn Passive Income- Our brilliant NFT’s not only look
                    absolutely incredible but they also produce tiger tokens
                    every single week with our staking opportunities.
                  </p>
                  <p className="text-white">
                    Do you want to expand your collection? Well then, we provide
                    a very simple way of doing so. If you already own 2 NFT’s
                    and you are looking to expand your collection, you can
                    simply breed one more baby tiger which provides you more
                    passive income. Due to the high energy levels the breeding
                    process requires, you will need 500 tokens to start breeding
                    another baby tiger, however, after owning three NFT’s, your
                    passive income levels will rise up.
                  </p>
                </div>
              </div>
            </div>
          </section>
          {/* faq */}

          {/* roadmap */}
          <section
            aria-label="section"
            className="no-bottom"
            style={{ position: "relative" }}
          >
            {/* <div className="circle-ripple"></div> */}
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-12 text-center">
                  <h2 className="style-2 about_h2">Roadmap</h2>
                  <br />
                  <br />
                </div>
                <div className="col-lg-12">
                  <div className="timeline">
                    <div className="containerr left">
                      <i className="icon fa fa-home"></i>
                      <div className="content">
                        <h2>0-25%</h2>
                        <p>
                          5 ETH will be distributed amongst 10 discord giveaway
                          winners! Make it to the top three to get a higher
                          amount!
                        </p>
                        <p>
                          2 ETH will be distributed amongst the 5 winners of our
                          pinned twitter status!
                        </p>
                        <p>
                          We will be airdropping 20 NFT’s to the top 10 most
                          engaged members of our discord community!
                        </p>
                        <p>
                          We will be re-investing funds from pre-sale into
                          marketing to create hype for public mint!
                        </p>
                      </div>
                    </div>
                    <div className="containerr right">
                      <i className="icon fa fa-gift"></i>
                      <div className="content">
                        <h2>25%</h2>
                        <span>
                          We will deposit $50,000 into the BT fund for ongoing
                          project developments, marketing campaigns, and floor
                          sweeps. During this phase, we will also be launching
                          the BT merchandise for sale.
                        </span>
                        <p>
                          We will be launching the staking feature so you get a
                          chance to receive free tokens while holding the NFT
                        </p>
                        <p>
                          An overall of 5 ETH will be distributed amongst the 5
                          lucky Billionaire Tiger holders with 1 ETH being given
                          to each individual
                        </p>
                        <p>
                          We will be distributing 10 Billionaire Tigers to 10
                          random holders out there
                        </p>
                        <p>We will be ramping up our marketing efforts</p>
                      </div>
                    </div>
                    <div className="containerr left">
                      <i className="icon fa fa-user"></i>
                      <div className="content">
                        <h2>50%</h2>
                        <p>
                          We will be creating an NGO wallet to help endangered
                          tigers all around the world!
                        </p>
                        <p>We will top up the NGO wallet.</p>
                      </div>
                    </div>
                    <div className="containerr right">
                      <i className="icon fa fa-trophy"></i>
                      <div className="content">
                        <h2>75%</h2>
                        <p>
                          To celebrate this incredible milestone, we will be
                          raffling off 10 Billionaire Tigers including one
                          Memorable Tiger amongst our special BT holders. Not
                          only that, but we will also be carrying out a daily
                          giveaway for 30 whole days with a total value of
                          $50,000!
                        </p>
                      </div>
                    </div>
                    <div className="containerr left">
                      <i className="icon fa fa-cog"></i>
                      <div className="content">
                        <h2>100%</h2>
                        <p>
                          We will create a private discord group for NFT owners
                        </p>
                        <p>
                          Each owner will be given one free NFT from our next
                          project.
                        </p>
                        <p>
                          We will be doing a Mega 10 ETH giveaway to 3 randomly
                          selected holders!
                        </p>
                        <p>
                          Every individual holder will be able to play our P2E
                          game
                        </p>
                        <p>Buy and Build on!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* roadmap */}

          <br />

          {/* cta */}
          <section aria-label="section">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-11">
                  <div
                    className="row justify-content-center"
                    style={{
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundImage: "url(images/background/word-nft.png)",
                      padding: "40px 40px",
                      borderRadius: "12px",
                    }}
                  >
                    <div className="col-sm-6 text-center">
                      <div>
                        <h2 className="text-white" style={{ margin: 0 }}>
                          2.5 ETH Giveaways!!
                          <br /> Join Our <Link to="/">Discord</Link> Today
                        </h2>
                      </div>
                    </div>
                    <div
                      className="col-sm-6 text-center"
                      style={{ margin: "auto" }}
                    >
                      <div>
                        <button className="btn join_btn">Join Discord</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* cta */}

          {/* team */}
          <section
            aria-label="section"
            style={{
              background:
                'url("images/background/section-bg.png") center center / auto no-repeat',
            }}
            className="no-bottom team_section"
          >
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-12 text-center">
                  <h2 className="style-2 about_h2">Our Team</h2>
                  <br />
                  <br />
                </div>
                <div className="col-lg-6 col-md-9">
                  <div className="row">
                    <div className="col-lg-6 col-sm-6 mb40 boxxx">
                      <Link
                        className="box-url style-2"
                        to="/"
                        style={{
                          backgroundImage: "url(images/tiger_art/Baby1.png)",
                        }}
                      ></Link>
                      <h4 style={{ color: "#f89213", marginBottom: "8px" }}>
                        Nikhil
                      </h4>
                      <h5 className="text-center">Project Manager/Marketing</h5>
                    </div>

                    <div className="col-lg-6 col-sm-6 mb40 boxxx">
                      <Link
                        className="box-url style-2"
                        to="/"
                        style={{
                          backgroundImage: "url(images/tiger_art/Baby2.png)",
                        }}
                      ></Link>
                      <h4 style={{ color: "#f89213", marginBottom: "8px" }}>
                        Xeu
                      </h4>
                      <h5 className="text-center">
                        Graphics/Illustration Expert
                      </h5>
                    </div>

                    <div className="col-lg-6 col-sm-6 mb40 boxxx">
                      <Link
                        className="box-url style-2"
                        to="/"
                        style={{
                          backgroundImage: "url(images/tiger_art/Baby3.png)",
                        }}
                      ></Link>
                      <h4 style={{ color: "#f89213", marginBottom: "8px" }}>
                        Pallavi
                      </h4>
                      <h5 className="text-center">
                        Blockchain Dev/Crypto Maniac
                      </h5>
                    </div>

                    <div className="col-lg-6 col-sm-6 mb40 boxxx">
                      <Link
                        className="box-url style-2"
                        to="/"
                        style={{
                          backgroundImage:
                            "url(images/tiger_art/Babysilver.png)",
                        }}
                      ></Link>
                      <h4 style={{ color: "#f89213", marginBottom: "8px" }}>
                        Pallavi
                      </h4>
                      <h5 className="text-center">Frontend/Backend Dev</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* team */}

          {/* faq */}
          <section aria-label="section">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-12 text-center">
                  <h2 className="style-2 about_h2">FAQ's</h2>
                  <br />
                  <br />
                </div>
                <div className="col-lg-10">
                  <div className="general_faqs">
                    <div className="faq jquery-accordion">
                      <div
                        className={
                          current_tab === "list_1"
                            ? "item jquery-accordion-active"
                            : "item"
                        }
                        onClick={() => handleClick("list_1")}
                      >
                        <div className="question">
                          <h4>What is a Billionaire Tiger NFT</h4>
                          <i className="fa fa-plus bx-plus"></i>
                          <i className="fa fa-minus bx-minus"></i>
                        </div>
                        <div className="answer">
                          <p>
                            The Billionaire Tigers are 5,000 randomly generated
                            tigers, with proof of ownership stored on the
                            Ethereum network, as an ERC 721 mint.The Billionaire
                            Tiger NFTs have been categorized into 3 groups-
                            Male, Female, and Babies. Each Billionaire Tiger
                            owns its own unique personality as is demonstrated
                            by its styles. Their visual identities were created
                            to classify an “each to its own” design approach
                            which was adapted from the original solitary
                            approach of a tiger while hunting and that is what
                            simply makes them all individually valuable. Not
                            only do their distinctive characters enhance the
                            appearance of the Billionaire Tigers but they also
                            increase the value of each NFT.
                          </p>
                        </div>
                      </div>
                      <div
                        className={
                          current_tab === "list_2"
                            ? "item jquery-accordion-active"
                            : "item"
                        }
                        onClick={() => handleClick("list_2")}
                      >
                        <div className="question">
                          <h4>How do I mint a Billionaire Tiger NFT?</h4>
                          <i className="fa fa-plus bx-plus"></i>
                          <i className="fa fa-minus bx-minus"></i>
                        </div>
                        <div className="answer">
                          <p>
                            You can mint a Billionaire Tiger NFT on February
                            20th which is the launch date for the Billionaire
                            Tigers NFT. Minting is best done on metamask however
                            more information will be provided on launch date.
                          </p>
                        </div>
                      </div>
                      <div
                        className={
                          current_tab === "list_3"
                            ? "item jquery-accordion-active"
                            : "item"
                        }
                        onClick={() => handleClick("list_3")}
                      >
                        <div className="question">
                          <h4>What can I do with my Billionaire Tiger NFT?</h4>
                          <i className="fa fa-plus bx-plus"></i>
                          <i className="fa fa-minus bx-minus"></i>
                        </div>
                        <div className="answer">
                          <p>
                            Owning a Billionaire Tiger NFT comes with full
                            copyright claims and user sovereignty over the
                            public key it’s tied to.This means that any
                            Billionaire tiger holder has the absolute right to
                            use it as it see’s fit; from profile picture or
                            choice of auctioning it out for sale. A holder can
                            also stake their NFT to earn passive income.
                          </p>
                        </div>
                      </div>
                      <div
                        className={
                          current_tab === "list_4"
                            ? "item jquery-accordion-active"
                            : "item"
                        }
                        onClick={() => handleClick("list_4")}
                      >
                        <div className="question">
                          <h4>Will there be a presale?</h4>
                          <i className="fa fa-plus bx-plus"></i>
                          <i className="fa fa-minus bx-minus"></i>
                        </div>
                        <div className="answer">
                          <p>
                            Yes there will be a presale one day before the
                            public launch. The presale will be for whitelisted
                            members only. Please, join the Billionaire Tiger
                            discord community to learn more about the whitelist.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* faq */}
        </div>
        {/* content close  */}

        <Link to="/" id="back-to-top"></Link>
      </div>

      {/* footer begin  */}
      <Footer />
      {/* footer close */}
    </div>
  );
}
export default Home;
